<template>
  <div class="d-flex flex-row justify-space-between align-center">
    <div class="d-flex flex-row align-center pr-2">
      <div class="labels-wrapper">
        <v-chip
          v-for="(label, index) in newsItem._labels"
          :key="index"
          class="mr-1"
          :color="selectedLabelId === label.labelIdFk ? 'font-weight-bold' : ''"
          small
        >
          {{ labelsById[label.labelIdFk].label }}
        </v-chip>
      </div>
    </div>
    <div v-if="showAttachementCount">
      <pdf-count :newsItem="newsItem"></pdf-count>
    </div>
    <v-btn v-if="dotRead" class="btnPos ml-2" icon @click.stop.prevent="toggleReadState">
      <template>
        <v-icon :color="isRead ? 'grey' : theme.unreadBadgeColor">{{ isRead ? 'mdi-checkbox-blank-circle-outline' : 'mdi-checkbox-blank-circle' }} </v-icon>
      </template>
    </v-btn>
  </div>
</template>

<script>
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin.js';
import { mapState } from 'vuex';
import PdfCount from '../modules/news/components/PdfCount';
import readService from '@/services/readService';

export default {
  name: 'Subtitle1',
  components: {
    PdfCount,
  },
  mixins: [common, dateTimeMixin],
  props: {
    dotRead: { type: Boolean, default: false },
    newsItem: {
      type: Object,
    },
    showAttachementCount: { type: Boolean, default: true },
  },
  data() {
    return {
      isRead: readService.isRead(this.newsItem),
    };
  },
  computed: {
    ...mapState({
      labelsById: (state) => state.news.labelsById,
      selectedLabelId: (state) => state.news.selectedLabelId,
    }),
    readTranslation() {
      return this.$t(`${this.isRead ? 'seen' : 'unseen'}.${this.newsItem._moduleId}`);
    },
  },
  methods: {
    toggleReadState() {
      if (this.newsItem) {
        const isRead = this.isRead;

        let type = this.$t(`type.${this.newsItem._moduleId}`);
        let state = this.$t(`${isRead ? 'unseen' : 'seen'}.${this.newsItem._moduleId}`);
        let actionName = this.$t('action.marked');
        let sendboxTitle = this.newsItem.title;
        let snackbarText = this.$t('markAsMsg', { type, title: this.newsItem.title, state, actionName });

        let action = isRead ? 'markAsUnread2' : 'markAsRead2';

        this.$store.dispatch(
          `sendbox/${action}`,
          {
            item: this.newsItem,
            sendboxTitle,
            snackbarText,
            immediate: true,
          },
          { root: true }
        );
        this.isRead = !isRead;
      }
    },
  },
};
</script>

<style scoped>
.btnPos {
  margin-right: -9px;
}
</style>
<style>
.labels-wrapper {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: grey;
}
</style>
